module.exports = __webpack_public_path__ + "static/media/pficon.4f40e753.eot";